import { Root } from '@studio/design-system/button';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { DiagonalProps } from './types.js';
import { Sel, STagNew } from '#~/stag/tag.js';

/** `<Diagonal>` button component. */
export const Diagonal = ({ className, direction, ...props }: DiagonalProps): ReactElement => (
  // Per playwright-stag-selectors-only (ai.knowledge/platform): mirror
  // the orthogonal stagging pattern; preserves the `data-direction`
  // production contract that choreographer.tsx:27 reads.
  <Root
    className={twMerge('group absolute h-1/3 w-1/3', className)}
    data-direction={direction}
    tabIndex={-1}
    {...STagNew(Sel.MainRoomRightTrayControls, 'dpad-direction', direction)}
    {...props}
  >
    <svg viewBox='0 0 76 76'>
      <path
        className='fill-base-100 transition-colors group-hover:fill-secondary group-active:fill-primary'
        d='M16.9368 66C14.0132 66 12.0828 63.0023 13.4464 60.4388C24.0292 40.5436 40.4087 24.1483 60.3574 13.4608C62.9443 12.0749 66 13.9871 66 16.9019L66 62.024C66 64.2199 64.2041 66 61.9888 66L16.9368 66Z'
      />

      <path
        className='fill-secondary transition-colors group-hover:fill-foreground group-active:fill-foreground'
        d='M41.5391 42.4129C41.4234 42.0051 41.7931 41.6387 42.2045 41.7534L51.9238 44.4626C52.3352 44.5773 52.4798 45.087 52.1841 45.3801L45.198 52.305C44.9023 52.5981 44.388 52.4548 44.2724 52.047L41.5391 42.4129Z'
      />
    </svg>
  </Root>
);
